// @mui
import { Box, Stack, Dialog, Tooltip, IconButton, DialogActions } from '@mui/material';
// hooks
import useToggle from 'src/hooks/useToggle';

// components
import Iconify from 'src/components/Iconify';
//localization

import { themeMode } from 'src/utils/general';
import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { IRentPayment } from 'src/@types/Choqorak/MainTables/RentPayment.ts/RentPayment';
import ContractInfoReportPDF from './ContractInfoReportPDF';
import { ContractReport } from 'src/@types/Choqorak/MainTables/Contract/ContractInfo';

// ----------------------------------------------------------------------

type Props = {
  Report?: ContractReport;
};

export default function ContractInfoReportDetailsToolbar({ Report }: Props) {
  const { toggle: open, onClose } = useToggle();

  const print = () => {
    handlePrint();
  };

  const contentToPrint = useRef(null);
  const handlePrint = useReactToPrint({
    pageStyle: `
    @page { size: A4}; 
      `,
    content: () => contentToPrint.current,
  });

  //

  return (
    <>
      <Stack direction="row" spacing={1} sx={{ borderRadius: 1, ml: 1 }}>
        <>
          <Tooltip title="Print">
            <IconButton sx={{ color: themeMode() === 'light' ? 'black' : 'white' }} onClick={print}>
              <Iconify icon={'eva:printer-fill'} />
            </IconButton>
          </Tooltip>
        </>
      </Stack>

      <Dialog fullScreen open={open}>
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
          <DialogActions
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              zIndex: 9,
              padding: '12px !important',
              boxShadow: (theme) => theme.customShadows.z8,
            }}
          >
            <Tooltip title="Print">
              <IconButton
                sx={{ color: themeMode() === 'light' ? 'black' : 'white' }}
                onClick={print}
              >
                <Iconify icon={'eva:printer-fill'} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Close">
              <IconButton color="inherit" onClick={onClose}>
                <Iconify icon={'eva:close-fill'} />
              </IconButton>
            </Tooltip>
          </DialogActions>
          <Box sx={{ flexGrow: 1, height: '100%', overflow: 'hidden' }}>
            <div className="h-full overflow-y-auto">
              <ContractInfoReportPDF Report={Report} />
            </div>
          </Box>
        </Box>
      </Dialog>
      <div ref={contentToPrint} className="hidden print:block">
        <ContractInfoReportPDF Report={Report} />
      </div>
    </>
  );
}
